// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../api/axiosInstance";
// import { toast } from "react-hot-toast";

// const Profile = () => {
//   const [member, setMember] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [editing, setEditing] = useState(false);
//   const [formData, setFormData] = useState({});
//   const [paymentHistory, setPaymentHistory] = useState([]);
//   const [pendingPayments, setPendingPayments] = useState([]);
//   const [activeTab, setActiveTab] = useState("profile");
//   const navigate = useNavigate();

//   const fetchProfile = async () => {
//     try {
//       const res = await api.get("/profile");
//       const memberData = res.data.member || res.data;
//       setMember(memberData);
//       setFormData({
//         firstName: memberData.firstName || "",
//         lastName: memberData.lastName || "",
//         mobile: memberData.mobile || "",
//         occupation: memberData.occupation || "",
//         bloodGroup: memberData.bloodGroup || "",
//         officialAddress: memberData.officialAddress || "",
//         presentAddress: memberData.presentAddress || "",
//         permanentAddress: memberData.permanentAddress || "",
//         monthlyIncome: memberData.monthlyIncome || 0,
//       });
//     } catch (error) {
//       console.error("Error fetching profile:", error);
//       toast.error("Failed to load profile");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchPaymentData = async () => {
//     try {
//       const [historyRes, pendingRes] = await Promise.all([
//         api.get("/payment/history"),
//         api.get("/payment/pending"),
//       ]);
//       setPaymentHistory(historyRes.data);
//       setPendingPayments(pendingRes.data);
//     } catch (error) {
//       console.error("Error fetching payment data:", error);
//     }
//   };

//   useEffect(() => {
//     fetchProfile();
//     fetchPaymentData();
//   }, []);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSave = async () => {
//     try {
//       const res = await api.put("/profile", formData);
//       setMember(res.data.member || res.data);
//       setEditing(false);
//       toast.success("Profile updated successfully");
//     } catch (error) {
//       console.error("Error updating profile:", error);
//       toast.error("Failed to update profile");
//     }
//   };

//   const handleCancel = () => {
//     setFormData({
//       firstName: member.firstName || "",
//       lastName: member.lastName || "",
//       mobile: member.mobile || "",
//       occupation: member.occupation || "",
//       bloodGroup: member.bloodGroup || "",
//       officialAddress: member.officialAddress || "",
//       presentAddress: member.presentAddress || "",
//       permanentAddress: member.permanentAddress || "",
//       monthlyIncome: member.monthlyIncome || 0,
//     });
//     setEditing(false);
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-100 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div>
//           <p className="mt-4 text-gray-600">Loading profile...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-100">
//       {/* Header with Edit Mode Indicator */}
//       <header
//         className={`bg-white shadow-sm ${
//           editing ? "border-l-4 border-green-500" : ""
//         }`}
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between items-center py-4">
//             <div>
//               <button
//                 onClick={() => navigate("/dashboard")}
//                 className="flex items-center text-gray-600 hover:text-gray-900 mb-2"
//               >
//                 <svg
//                   className="w-3 h-4 mr-1"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M15 19l-7-7 7-7"
//                   />
//                 </svg>
//                 Back to Dashboard
//               </button>
//               <div className="flex items-center space-x-3">
//                 <h1 className="text-2xl font-bold text-gray-900">My Profile</h1>
//                 {editing && (
//                   <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800 animate-pulse">
//                     <svg
//                       className="w-4 h-4 mr-1"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
//                       />
//                     </svg>
//                     Editing Mode
//                   </span>
//                 )}
//               </div>
//             </div>
//             <div className="flex items-center space-x-4">
//               {!editing ? (
//                 <button
//                   onClick={() => setEditing(true)}
//                   className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition flex items-center"
//                 >
//                   <svg
//                     className="w-4 h-4 mr-2"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
//                     />
//                   </svg>
//                   Edit Profile
//                 </button>
//               ) : (
//                 <div className="flex space-x-2">
//                   <button
//                     onClick={handleSave}
//                     className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition flex items-center"
//                   >
//                     <svg
//                       className="w-4 h-4 mr-2"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     Save Changes
//                   </button>
//                   <button
//                     onClick={handleCancel}
//                     className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition flex items-center"
//                   >
//                     <svg
//                       className="w-4 h-4 mr-2"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M6 18L18 6M6 6l12 12"
//                       />
//                     </svg>
//                     Cancel
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </header>

//       <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         {/* Profile Header with Photo */}
//         <div
//           className={`bg-white rounded-lg shadow-sm p-6 mb-6 transition-all duration-200 ${
//             editing ? "ring-2 ring-green-200" : ""
//           }`}
//         >
//           <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-6">
//             {/* Profile Picture */}
//             <div className="flex-shrink-0 relative">
//               {member.profilePicture ? (
//                 <img
//                   src={member.profilePicture}
//                   alt={`${member.firstName} ${member.lastName}`}
//                   className="w-24 h-24 rounded-full object-cover border-4 border-green-100"
//                 />
//               ) : (
//                 <div className="w-24 h-24 rounded-full bg-green-100 flex items-center justify-center border-4 border-green-200">
//                   <span className="text-2xl font-bold text-green-600">
//                     {member.firstName?.charAt(0)}
//                     {member.lastName?.charAt(0)}
//                   </span>
//                 </div>
//               )}
//               {editing && (
//                 <div className="absolute -bottom-2 -right-2 bg-green-500 text-white p-1 rounded-full">
//                   <svg
//                     className="w-4 h-4"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
//                     />
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
//                     />
//                   </svg>
//                 </div>
//               )}
//             </div>

//             {/* Member Info */}
//             <div className="text-center md:text-left">
//               <div className="flex flex-col md:flex-row md:items-center space-y-2 md:space-y-0 md:space-x-3">
//                 <h2 className="text-2xl font-bold text-gray-900">
//                   {editing ? (
//                     <div className="flex items-center space-x-2">
//                       <input
//                         type="text"
//                         name="firstName"
//                         value={formData.firstName}
//                         onChange={handleInputChange}
//                         className="text-2xl font-bold px-3 py-1 border-2 border-green-300 rounded-lg bg-green-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
//                         placeholder="First Name"
//                       />
//                       <input
//                         type="text"
//                         name="lastName"
//                         value={formData.lastName}
//                         onChange={handleInputChange}
//                         className="text-2xl font-bold px-3 py-1 border-2 border-green-300 rounded-lg bg-green-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
//                         placeholder="Last Name"
//                       />
//                     </div>
//                   ) : (
//                     `${member.firstName} ${member.lastName}`
//                   )}
//                 </h2>
//                 {editing && (
//                   <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-yellow-100 text-yellow-800">
//                     Editable
//                   </span>
//                 )}
//               </div>
//               <p className="text-gray-600 mt-1">{member.email}</p>
//               <p
//                 className={`text-gray-500 text-sm mt-1 ${
//                   editing ? "flex items-center" : ""
//                 }`}
//               >
//                 {editing ? (
//                   <input
//                     type="text"
//                     name="mobile"
//                     value={formData.mobile}
//                     onChange={handleInputChange}
//                     className="px-3 py-1 border-2 border-green-300 rounded-lg bg-green-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
//                     placeholder="Mobile Number"
//                   />
//                 ) : (
//                   member.mobile
//                 )}
//               </p>
//               <div className="flex flex-wrap gap-2 mt-3 justify-center md:justify-start">
//                 <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
//                   {member.membershipCategory}
//                 </span>
//                 <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
//                   {member.membershipType}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Tab Navigation */}
//         <div className="bg-white rounded-lg shadow-sm mb-6">
//           <div className="border-b border-gray-200">
//             <nav className="flex -mb-px">
//               <button
//                 onClick={() => setActiveTab("profile")}
//                 className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${
//                   activeTab === "profile"
//                     ? "border-green-500 text-green-600"
//                     : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                 }`}
//               >
//                 Profile Information
//               </button>
//               <button
//                 onClick={() => setActiveTab("payment-history")}
//                 className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${
//                   activeTab === "payment-history"
//                     ? "border-green-500 text-green-600"
//                     : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                 }`}
//               >
//                 Payment History
//               </button>
//               <button
//                 onClick={() => setActiveTab("pending-payments")}
//                 className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${
//                   activeTab === "pending-payments"
//                     ? "border-green-500 text-green-600"
//                     : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                 }`}
//               >
//                 Pending Payments
//               </button>
//             </nav>
//           </div>
//         </div>

//         {/* Profile Tab */}
//         {activeTab === "profile" && (
//           <div
//             className={`bg-white rounded-lg shadow-sm p-6 transition-all duration-200 ${
//               editing ? "ring-2 ring-green-100" : ""
//             }`}
//           >
//             {/* Edit Mode Banner */}
//             {editing && (
//               <div className="mb-6 p-4 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg border border-green-200">
//                 <div className="flex items-center">
//                   <div className="flex-shrink-0">
//                     <svg
//                       className="h-5 w-5 text-green-400"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                       />
//                     </svg>
//                   </div>
//                   <div className="ml-3">
//                     <h3 className="text-sm font-medium text-green-800">
//                       You're in editing mode
//                     </h3>
//                     <div className="mt-2 text-sm text-green-700">
//                       <p>
//                         All fields with{" "}
//                         <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
//                           Editable
//                         </span>{" "}
//                         badge can be modified.
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//               {/* Personal Information */}
//               <div className="space-y-6">
//                 <div className="flex items-center justify-between">
//                   <h3 className="text-lg font-semibold text-gray-900">
//                     Personal Information
//                   </h3>
//                   {editing && (
//                     <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800">
//                       <svg
//                         className="w-3 h-3 mr-1"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
//                         />
//                       </svg>
//                       Editable Section
//                     </span>
//                   )}
//                 </div>

//                 {[
//                   {
//                     label: "First Name",
//                     name: "firstName",
//                     type: "text",
//                     editable: true,
//                   },
//                   {
//                     label: "Last Name",
//                     name: "lastName",
//                     type: "text",
//                     editable: true,
//                   },
//                   {
//                     label: "Email",
//                     name: "email",
//                     type: "text",
//                     editable: false,
//                   },
//                   {
//                     label: "Mobile",
//                     name: "mobile",
//                     type: "text",
//                     editable: true,
//                   },
//                   {
//                     label: "Occupation",
//                     name: "occupation",
//                     type: "text",
//                     editable: true,
//                   },
//                   {
//                     label: "Blood Group",
//                     name: "bloodGroup",
//                     type: "text",
//                     editable: true,
//                   },
//                 ].map((field) => (
//                   <div key={field.name} className="space-y-1">
//                     <div className="flex items-center justify-between">
//                       <label className="block text-sm font-medium text-gray-700">
//                         {field.label}
//                       </label>
//                       {editing && field.editable && (
//                         <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
//                           Editable
//                         </span>
//                       )}
//                     </div>
//                     {editing && field.editable ? (
//                       <input
//                         type={field.type}
//                         name={field.name}
//                         value={formData[field.name]}
//                         onChange={handleInputChange}
//                         className="w-full px-4 py-3 border-2 border-green-300 rounded-lg bg-green-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
//                       />
//                     ) : (
//                       <p
//                         className={`text-gray-900 px-4 py-3 rounded-lg ${
//                           editing && field.editable
//                             ? "bg-yellow-50 border border-yellow-200"
//                             : "bg-gray-50"
//                         }`}
//                       >
//                         {field.name === "email"
//                           ? member.email
//                           : formData[field.name]}
//                       </p>
//                     )}
//                   </div>
//                 ))}
//               </div>

//               {/* Address Information */}
//               <div className="space-y-6">
//                 <div className="flex items-center justify-between">
//                   <h3 className="text-lg font-semibold text-gray-900">
//                     Address Information
//                   </h3>
//                   {editing && (
//                     <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800">
//                       <svg
//                         className="w-3 h-3 mr-1"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
//                         />
//                       </svg>
//                       Editable Section
//                     </span>
//                   )}
//                 </div>

//                 {[
//                   {
//                     label: "Official Address",
//                     name: "officialAddress",
//                     type: "textarea",
//                   },
//                   {
//                     label: "Present Address",
//                     name: "presentAddress",
//                     type: "textarea",
//                   },
//                   {
//                     label: "Permanent Address",
//                     name: "permanentAddress",
//                     type: "textarea",
//                   },
//                   {
//                     label: "Monthly Income",
//                     name: "monthlyIncome",
//                     type: "number",
//                   },
//                 ].map((field) => (
//                   <div key={field.name} className="space-y-1">
//                     <div className="flex items-center justify-between">
//                       <label className="block text-sm font-medium text-gray-700">
//                         {field.label}
//                       </label>
//                       {editing && (
//                         <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
//                           Editable
//                         </span>
//                       )}
//                     </div>
//                     {editing ? (
//                       field.type === "textarea" ? (
//                         <textarea
//                           name={field.name}
//                           value={formData[field.name]}
//                           onChange={handleInputChange}
//                           rows="3"
//                           className="w-full px-4 py-3 border-2 border-green-300 rounded-lg bg-green-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
//                         />
//                       ) : (
//                         <input
//                           type={field.type}
//                           name={field.name}
//                           value={formData[field.name]}
//                           onChange={handleInputChange}
//                           className="w-full px-4 py-3 border-2 border-green-300 rounded-lg bg-green-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
//                         />
//                       )
//                     ) : (
//                       <p className="text-gray-900 px-4 py-3 rounded-lg bg-gray-50">
//                         {field.name === "monthlyIncome"
//                           ? `৳ ${formData[field.name]?.toLocaleString()}`
//                           : formData[field.name]}
//                       </p>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Membership Status (Read-only) */}
//             <div className="mt-8 pt-8 border-t border-gray-200">
//               <div className="flex items-center justify-between mb-4">
//                 <h3 className="text-lg font-semibold text-gray-900">
//                   Membership Status
//                 </h3>
//                 <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-gray-100 text-gray-800">
//                   Read Only
//                 </span>
//               </div>
//               <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                 <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
//                   <p className="text-sm text-gray-600">Membership Category</p>
//                   <p className="font-semibold text-gray-900">
//                     {member.membershipCategory}
//                   </p>
//                 </div>
//                 <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
//                   <p className="text-sm text-gray-600">Membership Type</p>
//                   <p className="font-semibold text-gray-900">
//                     {member.membershipType}
//                   </p>
//                 </div>
//                 <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
//                   <p className="text-sm text-gray-600">Registration Status</p>
//                   <p className="font-semibold text-gray-900">
//                     {member.registrationStatus}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Payment History Tab */}
//         {activeTab === "payment-history" && (
//           <div className="bg-white rounded-lg shadow-sm p-6">
//             <h3 className="text-lg font-semibold text-gray-900 mb-4">
//               Payment History
//             </h3>
//             {paymentHistory.length > 0 ? (
//               <div className="overflow-x-auto">
//                 <table className="min-w-full divide-y divide-gray-200">
//                   <thead className="bg-gray-50">
//                     <tr>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Date
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Amount
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Description
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Status
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {paymentHistory.map((payment, index) => (
//                       <tr key={index}>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                           {new Date(payment.paymentDate).toLocaleDateString()}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                           ৳ {payment.amount?.toLocaleString()}
//                         </td>
//                         <td className="px-6 py-4 text-sm text-gray-900">
//                           {payment.description}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap">
//                           <span
//                             className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
//                               payment.status === "SUCCESS"
//                                 ? "bg-green-100 text-green-800"
//                                 : payment.status === "PENDING"
//                                 ? "bg-yellow-100 text-yellow-800"
//                                 : "bg-red-100 text-red-800"
//                             }`}
//                           >
//                             {payment.status}
//                           </span>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             ) : (
//               <p className="text-gray-500 text-center py-8">
//                 No payment history found.
//               </p>
//             )}
//           </div>
//         )}

//         {/* Pending Payments Tab */}
//         {activeTab === "pending-payments" && (
//           <div className="bg-white rounded-lg shadow-sm p-6">
//             <h3 className="text-lg font-semibold text-gray-900 mb-4">
//               Pending Payments
//             </h3>
//             {pendingPayments.length > 0 ? (
//               <div className="overflow-x-auto">
//                 <table className="min-w-full divide-y divide-gray-200">
//                   <thead className="bg-gray-50">
//                     <tr>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Due Date
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Amount
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Description
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Action
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {pendingPayments.map((payment, index) => (
//                       <tr key={index}>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                           {new Date(payment.dueDate).toLocaleDateString()}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                           ৳ {payment.amount?.toLocaleString()}
//                         </td>
//                         <td className="px-6 py-4 text-sm text-gray-900">
//                           {payment.description}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                           <button
//                             onClick={() =>
//                               navigate("/payment-checkout", {
//                                 state: { payment },
//                               })
//                             }
//                             className="text-green-600 hover:text-green-900 font-medium flex items-center"
//                           >
//                             <svg
//                               className="w-4 h-4 mr-1"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
//                               />
//                             </svg>
//                             Pay Now
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             ) : (
//               <p className="text-gray-500 text-center py-8">
//                 No pending payments.
//               </p>
//             )}
//           </div>
//         )}
//       </main>
//     </div>
//   );
// };

// export default Profile;

import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axiosInstance";
import { toast } from "react-hot-toast";
import { AuthContext } from "../context/AuthContext";
import {
  User,
  Edit2,
  Save,
  X,
  ArrowLeft,
  CreditCard,
  Calendar,
  MapPin,
  Briefcase,
  DollarSign,
  Shield,
  Award,
  Clock,
  CheckCircle,
  AlertCircle,
  Mail,
  Phone,
  Home,
  Building,
  FileText,
  Download,
  Eye,
  Camera,
  History,
  Bell,
} from "lucide-react";

const Profile = () => {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [pendingPayments, setPendingPayments] = useState([]);
  const [activeTab, setActiveTab] = useState("profile");
  const navigate = useNavigate();
  const { logout: logoutContext } = useContext(AuthContext);

  const fetchProfile = async () => {
    try {
      const res = await api.get("/profile");
      const memberData = res.data.member || res.data;
      setMember(memberData);
      setFormData({
        firstName: memberData.firstName || "",
        lastName: memberData.lastName || "",
        mobile: memberData.mobile || "",
        occupation: memberData.occupation || "",
        bloodGroup: memberData.bloodGroup || "",
        officialAddress: memberData.officialAddress || "",
        presentAddress: memberData.presentAddress || "",
        permanentAddress: memberData.permanentAddress || "",
        monthlyIncome: memberData.monthlyIncome || 0,
      });
    } catch (error) {
      console.error("Error fetching profile:", error);
      toast.error("Session expired. Please log in again.");
      logoutContext();
      localStorage.clear();
      navigate("/login", { replace: true });
    } finally {
      setLoading(false);
    }
  };

  const fetchPaymentData = async () => {
    try {
      const [historyRes, pendingRes] = await Promise.all([
        api.get("/payment/history"),
        api.get("/payment/pending"),
      ]);
      setPaymentHistory(historyRes.data);
      setPendingPayments(pendingRes.data);
    } catch (error) {
      console.error("Error fetching payment data:", error);
    }
  };

  useEffect(() => {
    fetchProfile();
    fetchPaymentData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
      const res = await api.put("/profile", formData);
      setMember(res.data.member || res.data);
      setEditing(false);
      toast.success("Profile updated successfully");
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Failed to update profile");
    }
  };

  const handleCancel = () => {
    setFormData({
      firstName: member.firstName || "",
      lastName: member.lastName || "",
      mobile: member.mobile || "",
      occupation: member.occupation || "",
      bloodGroup: member.bloodGroup || "",
      officialAddress: member.officialAddress || "",
      presentAddress: member.presentAddress || "",
      permanentAddress: member.permanentAddress || "",
      monthlyIncome: member.monthlyIncome || 0,
    });
    setEditing(false);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50 flex items-center justify-center">
        <div className="text-center">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-20"></div>
            <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-emerald-50 to-lime-50 border-2 border-emerald-100 flex items-center justify-center">
              <div className="w-8 h-8 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          </div>
          <p className="mt-6 text-gray-600 font-medium">
            Loading your profile...
          </p>
        </div>
      </div>
    );
  }

  if (!member) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50">
      {/* Header */}
      <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-sm border-b border-emerald-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate("/dashboard")}
                className="flex items-center gap-2 text-emerald-600 hover:text-emerald-800 hover:bg-emerald-50 px-3 py-2 rounded-lg transition-colors duration-200"
              >
                <ArrowLeft className="w-4 h-4" />
                <span className="font-medium">Dashboard</span>
              </button>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-100 to-lime-100 flex items-center justify-center">
                  <User className="w-5 h-5 text-emerald-600" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">
                    My Profile
                  </h1>
                  <p className="text-sm text-gray-500">
                    Manage your account details
                  </p>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-3">
              {!editing ? (
                <button
                  onClick={() => setEditing(true)}
                  className="flex items-center gap-2 px-6 py-2.5 rounded-xl font-semibold text-white bg-gradient-to-r from-emerald-500 to-lime-500 hover:from-emerald-600 hover:to-lime-600 transition-all duration-300 transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl"
                >
                  <Edit2 className="w-4 h-4" />
                  Edit Profile
                </button>
              ) : (
                <div className="flex items-center gap-2">
                  <button
                    onClick={handleCancel}
                    className="flex items-center gap-2 px-6 py-2.5 rounded-xl font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 transition-all duration-300"
                  >
                    <X className="w-4 h-4" />
                    Cancel
                  </button>
                  <button
                    onClick={handleSave}
                    className="flex items-center gap-2 px-6 py-2.5 rounded-xl font-semibold text-white bg-gradient-to-r from-emerald-500 to-lime-500 hover:from-emerald-600 hover:to-lime-600 transition-all duration-300 transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl"
                  >
                    <Save className="w-4 h-4" />
                    Save Changes
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Profile Header */}
        <div
          className={`bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8 mb-8 border-2 transition-all duration-300 ${
            editing ? "border-emerald-300" : "border-emerald-100"
          }`}
        >
          <div className="flex flex-col md:flex-row items-center gap-8">
            {/* Profile Picture */}
            <div className="relative group">
              <div className="absolute -inset-4 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>
              <div className="relative">
                {member.profilePicture ? (
                  <img
                    src={member.profilePicture}
                    alt={`${member.firstName} ${member.lastName}`}
                    className="w-32 h-32 rounded-2xl object-cover border-4 border-white shadow-xl"
                  />
                ) : (
                  <div className="w-32 h-32 rounded-2xl bg-gradient-to-br from-emerald-100 to-lime-100 border-4 border-white flex items-center justify-center shadow-xl">
                    <span className="text-4xl font-bold text-emerald-600">
                      {member.firstName?.charAt(0)}
                      {member.lastName?.charAt(0)}
                    </span>
                  </div>
                )}

                {editing && (
                  <button className="absolute bottom-2 right-2 w-10 h-10 rounded-full bg-gradient-to-r from-emerald-500 to-lime-500 text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300">
                    <Camera className="w-4 h-4" />
                  </button>
                )}
              </div>
            </div>

            {/* Member Info */}
            <div className="flex-1 text-center md:text-left">
              <div className="mb-4">
                <div className="flex flex-col md:flex-row md:items-center gap-3 mb-3">
                  {editing ? (
                    <div className="flex flex-col md:flex-row gap-3">
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        className="text-3xl font-bold px-4 py-2 border-2 border-emerald-300 rounded-xl bg-emerald-50 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                        placeholder="First Name"
                      />
                      <input
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        className="text-3xl font-bold px-4 py-2 border-2 border-emerald-300 rounded-xl bg-emerald-50 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                        placeholder="Last Name"
                      />
                    </div>
                  ) : (
                    <h2 className="text-3xl font-bold text-gray-900">
                      {member.firstName} {member.lastName}
                    </h2>
                  )}

                  {editing && (
                    <div className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200">
                      <Edit2 className="w-3 h-3 text-amber-600" />
                      <span className="text-xs font-semibold text-amber-700">
                        Editing
                      </span>
                    </div>
                  )}
                </div>

                <div className="flex flex-col md:flex-row md:items-center gap-4">
                  <div className="flex items-center gap-2 text-gray-600">
                    <Mail className="w-4 h-4" />
                    <span>{member.email}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-600">
                    <Phone className="w-4 h-4" />
                    {editing ? (
                      <input
                        type="text"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleInputChange}
                        className="px-3 py-1 border-2 border-emerald-300 rounded-lg bg-emerald-50 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                        placeholder="Mobile Number"
                      />
                    ) : (
                      <span>{member.mobile}</span>
                    )}
                  </div>
                </div>
              </div>

              {/* Membership Badges */}
              <div className="flex flex-wrap gap-3">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-gradient-to-r from-emerald-50 to-lime-50 border border-emerald-100">
                  <Award className="w-4 h-4 text-emerald-600" />
                  <span className="font-semibold text-emerald-700">
                    {member.membershipCategory}
                  </span>
                </div>
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-100">
                  <Shield className="w-4 h-4 text-blue-600" />
                  <span className="font-semibold text-blue-700">
                    {member.membershipType}
                  </span>
                </div>
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-100">
                  <CheckCircle className="w-4 h-4 text-amber-600" />
                  <span className="font-semibold text-amber-700">
                    {member.registrationStatus}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl mb-8 border border-emerald-100">
          <div className="flex flex-wrap">
            <button
              onClick={() => setActiveTab("profile")}
              className={`flex items-center gap-3 px-8 py-4 font-semibold transition-all duration-300 ${
                activeTab === "profile"
                  ? "text-emerald-600 border-b-2 border-emerald-500 bg-gradient-to-r from-emerald-50/50 to-transparent"
                  : "text-gray-600 hover:text-emerald-600 hover:bg-gray-50"
              }`}
            >
              <User className="w-5 h-5" />
              Profile
            </button>
            <button
              onClick={() => setActiveTab("payment-history")}
              className={`flex items-center gap-3 px-8 py-4 font-semibold transition-all duration-300 ${
                activeTab === "payment-history"
                  ? "text-emerald-600 border-b-2 border-emerald-500 bg-gradient-to-r from-emerald-50/50 to-transparent"
                  : "text-gray-600 hover:text-emerald-600 hover:bg-gray-50"
              }`}
            >
              <History className="w-5 h-5" />
              Payment History
            </button>
            <button
              onClick={() => setActiveTab("pending-payments")}
              className={`flex items-center gap-3 px-8 py-4 font-semibold transition-all duration-300 ${
                activeTab === "pending-payments"
                  ? "text-emerald-600 border-b-2 border-emerald-500 bg-gradient-to-r from-emerald-50/50 to-transparent"
                  : "text-gray-600 hover:text-emerald-600 hover:bg-gray-50"
              }`}
            >
              <Bell className="w-5 h-5" />
              Pending Payments
              {pendingPayments.length > 0 && (
                <span className="px-2 py-1 text-xs font-bold bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-full">
                  {pendingPayments.length}
                </span>
              )}
            </button>
          </div>
        </div>

        {/* Profile Tab */}
        {activeTab === "profile" && (
          <div
            className={`bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8 border-2 transition-all duration-300 ${
              editing ? "border-emerald-300" : "border-emerald-100"
            }`}
          >
            {/* Edit Mode Banner */}
            {editing && (
              <div className="mb-8 p-6 rounded-xl bg-gradient-to-r from-emerald-50 to-lime-50 border border-emerald-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-100 to-lime-100 flex items-center justify-center flex-shrink-0">
                    <Edit2 className="w-6 h-6 text-emerald-600" />
                  </div>
                  <div className="flex-1">
                    <h4 className="font-bold text-emerald-800 mb-2">
                      Editing Mode Active
                    </h4>
                    <p className="text-emerald-700">
                      You can now update your personal information. All changes
                      will be saved when you click "Save Changes".
                    </p>
                  </div>
                </div>
              </div>
            )}

            <div className="grid lg:grid-cols-2 gap-8">
              {/* Personal Information */}
              <div>
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center">
                    <User className="w-5 h-5 text-emerald-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">
                    Personal Information
                  </h3>
                </div>

                <div className="space-y-6">
                  {[
                    {
                      label: "First Name",
                      name: "firstName",
                      icon: <User className="w-4 h-4" />,
                    },
                    {
                      label: "Last Name",
                      name: "lastName",
                      icon: <User className="w-4 h-4" />,
                    },
                    {
                      label: "Email",
                      name: "email",
                      icon: <Mail className="w-4 h-4" />,
                      readOnly: true,
                    },
                    {
                      label: "Mobile",
                      name: "mobile",
                      icon: <Phone className="w-4 h-4" />,
                    },
                    {
                      label: "Occupation",
                      name: "occupation",
                      icon: <Briefcase className="w-4 h-4" />,
                    },
                    {
                      label: "Blood Group",
                      name: "bloodGroup",
                      icon: <AlertCircle className="w-4 h-4" />,
                    },
                  ].map((field) => (
                    <div key={field.name} className="space-y-2">
                      <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                        {field.icon}
                        {field.label}
                        {editing && !field.readOnly && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-emerald-100 text-emerald-800">
                            Editable
                          </span>
                        )}
                      </label>
                      {editing && !field.readOnly ? (
                        <input
                          type="text"
                          name={field.name}
                          value={formData[field.name]}
                          onChange={handleInputChange}
                          className="w-full px-4 py-3 border-2 border-emerald-300 rounded-xl bg-emerald-50 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200"
                          placeholder={`Enter ${field.label.toLowerCase()}`}
                        />
                      ) : (
                        <div className="px-4 py-3 rounded-xl bg-gray-50 border border-gray-200">
                          <p className="text-gray-900">
                            {field.name === "email"
                              ? member.email
                              : formData[field.name]}
                          </p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Address & Financial Information */}
              <div>
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-50 to-cyan-50 flex items-center justify-center">
                    <Home className="w-5 h-5 text-blue-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">
                    Address & Financial
                  </h3>
                </div>

                <div className="space-y-6">
                  {[
                    {
                      label: "Official Address",
                      name: "officialAddress",
                      icon: <Building className="w-4 h-4" />,
                    },
                    {
                      label: "Present Address",
                      name: "presentAddress",
                      icon: <MapPin className="w-4 h-4" />,
                    },
                    {
                      label: "Permanent Address",
                      name: "permanentAddress",
                      icon: <Home className="w-4 h-4" />,
                    },
                  ].map((field) => (
                    <div key={field.name} className="space-y-2">
                      <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                        {field.icon}
                        {field.label}
                        {editing && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-emerald-100 text-emerald-800">
                            Editable
                          </span>
                        )}
                      </label>
                      {editing ? (
                        <textarea
                          name={field.name}
                          value={formData[field.name]}
                          onChange={handleInputChange}
                          rows="3"
                          className="w-full px-4 py-3 border-2 border-emerald-300 rounded-xl bg-emerald-50 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 resize-none"
                          placeholder={`Enter ${field.label.toLowerCase()}`}
                        />
                      ) : (
                        <div className="px-4 py-3 rounded-xl bg-gray-50 border border-gray-200">
                          <p className="text-gray-900">
                            {formData[field.name]}
                          </p>
                        </div>
                      )}
                    </div>
                  ))}

                  {/* Monthly Income */}
                  <div className="space-y-2">
                    <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                      <DollarSign className="w-4 h-4" />
                      Monthly Income
                      {editing && (
                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-emerald-100 text-emerald-800">
                          Editable
                        </span>
                      )}
                    </label>
                    {editing ? (
                      <div className="relative">
                        <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500">
                          ৳
                        </span>
                        <input
                          type="number"
                          name="monthlyIncome"
                          value={formData.monthlyIncome}
                          onChange={handleInputChange}
                          className="w-full pl-10 pr-4 py-3 border-2 border-emerald-300 rounded-xl bg-emerald-50 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200"
                          placeholder="Enter monthly income"
                        />
                      </div>
                    ) : (
                      <div className="px-4 py-3 rounded-xl bg-gradient-to-r from-emerald-50 to-lime-50 border border-emerald-100">
                        <p className="text-2xl font-bold text-emerald-600">
                          ৳{formData.monthlyIncome?.toLocaleString()}
                        </p>
                        <p className="text-sm text-emerald-700">Per month</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Membership Status */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-50 to-pink-50 flex items-center justify-center">
                  <Shield className="w-5 h-5 text-purple-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900">
                  Membership Status
                </h3>
              </div>

              <div className="grid md:grid-cols-3 gap-6">
                <div className="bg-gradient-to-br from-emerald-50 to-lime-50 rounded-xl p-6 border border-emerald-100">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-white flex items-center justify-center">
                      <Award className="w-6 h-6 text-emerald-600" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Category</p>
                      <p className="text-lg font-bold text-gray-900">
                        {member.membershipCategory}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 border border-blue-100">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-white flex items-center justify-center">
                      <FileText className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Type</p>
                      <p className="text-lg font-bold text-gray-900">
                        {member.membershipType}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 border border-amber-100">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-white flex items-center justify-center">
                      <CheckCircle className="w-6 h-6 text-amber-600" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Status</p>
                      <p className="text-lg font-bold text-gray-900">
                        {member.registrationStatus}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Payment History Tab */}
        {activeTab === "payment-history" && (
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8 border border-emerald-100">
            <div className="flex items-center justify-between mb-8">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center">
                  <History className="w-5 h-5 text-emerald-600" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">
                    Payment History
                  </h3>
                  <p className="text-sm text-gray-600">
                    All your completed transactions
                  </p>
                </div>
              </div>
              <button className="flex items-center gap-2 px-4 py-2 rounded-lg bg-emerald-50 text-emerald-700 hover:bg-emerald-100 transition-colors duration-200">
                <Download className="w-4 h-4" />
                Export
              </button>
            </div>

            {paymentHistory.length > 0 ? (
              <div className="space-y-4">
                {paymentHistory.map((payment, index) => (
                  <div
                    key={index}
                    className="bg-gradient-to-r from-gray-50 to-white rounded-xl p-6 border border-gray-200 hover:border-emerald-200 hover:shadow-lg transition-all duration-300"
                  >
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                      <div className="flex-1">
                        <div className="flex items-center gap-3 mb-2">
                          <div
                            className={`w-3 h-3 rounded-full ${
                              payment.status === "SUCCESS"
                                ? "bg-emerald-500"
                                : payment.status === "PENDING"
                                ? "bg-amber-500"
                                : "bg-red-500"
                            }`}
                          ></div>
                          <h4 className="font-semibold text-gray-900">
                            {payment.description}
                          </h4>
                        </div>
                        <div className="flex items-center gap-4 text-sm text-gray-600">
                          <div className="flex items-center gap-2">
                            <Calendar className="w-4 h-4" />
                            <span>
                              {new Date(
                                payment.paymentDate
                              ).toLocaleDateString()}
                            </span>
                          </div>
                          <div className="flex items-center gap-2">
                            <Clock className="w-4 h-4" />
                            <span>
                              {new Date(payment.paymentDate).toLocaleTimeString(
                                [],
                                { hour: "2-digit", minute: "2-digit" }
                              )}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="flex items-center gap-4">
                        <div className="text-right">
                          <p className="text-2xl font-bold text-gray-900">
                            ৳{payment.amount?.toLocaleString()}
                          </p>
                          <div
                            className={`px-3 py-1 rounded-full text-xs font-semibold inline-block ${
                              payment.status === "SUCCESS"
                                ? "bg-emerald-100 text-emerald-800"
                                : payment.status === "PENDING"
                                ? "bg-amber-100 text-amber-800"
                                : "bg-red-100 text-red-800"
                            }`}
                          >
                            {payment.status}
                          </div>
                        </div>
                        <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors duration-200">
                          <Eye className="w-5 h-5 text-gray-600" />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center mx-auto mb-4">
                  <CreditCard className="w-8 h-8 text-gray-400" />
                </div>
                <h4 className="text-lg font-semibold text-gray-700 mb-2">
                  No Payment History
                </h4>
                <p className="text-gray-500">
                  You haven't made any payments yet.
                </p>
              </div>
            )}
          </div>
        )}

        {/* Pending Payments Tab */}
        {activeTab === "pending-payments" && (
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8 border border-emerald-100">
            <div className="flex items-center justify-between mb-8">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-amber-50 to-orange-50 flex items-center justify-center">
                  <Bell className="w-5 h-5 text-amber-600" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">
                    Pending Payments
                  </h3>
                  <p className="text-sm text-gray-600">
                    Payments awaiting your action
                  </p>
                </div>
              </div>
              <div className="px-4 py-2 rounded-lg bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200">
                <p className="text-sm font-semibold text-amber-700">
                  Total Due: ৳
                  {pendingPayments
                    .reduce((sum, p) => sum + (p.amount || 0), 0)
                    .toLocaleString()}
                </p>
              </div>
            </div>

            {pendingPayments.length > 0 ? (
              <div className="space-y-4">
                {pendingPayments.map((payment, index) => (
                  <div
                    key={index}
                    className="bg-gradient-to-r from-amber-50/50 to-orange-50/50 rounded-xl p-6 border border-amber-200 hover:border-amber-300 hover:shadow-lg transition-all duration-300"
                  >
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
                      <div className="flex-1">
                        <div className="flex items-center gap-3 mb-2">
                          <div className="w-8 h-8 rounded-lg bg-gradient-to-r from-amber-500 to-orange-500 flex items-center justify-center">
                            <AlertCircle className="w-4 h-4 text-white" />
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900">
                              {payment.description}
                            </h4>
                            <p className="text-sm text-gray-600">
                              Due in{" "}
                              {Math.ceil(
                                (new Date(payment.dueDate) - new Date()) /
                                  (1000 * 60 * 60 * 24)
                              )}{" "}
                              days
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-4 text-sm text-gray-600">
                          <div className="flex items-center gap-2">
                            <Calendar className="w-4 h-4" />
                            <span>
                              Due:{" "}
                              {new Date(payment.dueDate).toLocaleDateString()}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col sm:flex-row items-center gap-4">
                        <div className="text-center sm:text-right">
                          <p className="text-3xl font-bold text-amber-600">
                            ৳{payment.amount?.toLocaleString()}
                          </p>
                          <p className="text-sm text-amber-700 font-medium">
                            Amount Due
                          </p>
                        </div>
                        <button
                          onClick={() =>
                            navigate("/payment-checkout", {
                              state: { payment },
                            })
                          }
                          className="px-6 py-3 rounded-xl font-semibold text-white bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 transition-all duration-300 transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl"
                        >
                          <div className="flex items-center gap-2">
                            <CreditCard className="w-4 h-4" />
                            Pay Now
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-emerald-100 to-lime-100 flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="w-8 h-8 text-emerald-600" />
                </div>
                <h4 className="text-lg font-semibold text-gray-700 mb-2">
                  All Clear!
                </h4>
                <p className="text-gray-500">You have no pending payments.</p>
              </div>
            )}
          </div>
        )}
      </main>
    </div>
  );
};

export default Profile;
